<div class="flight-summary" *ngIf="bound$ | async as b">
  <h5 class="font-heading-5 bold-type font-title-small" data-testid="flight-summary-title">
    {{ title }}
  </h5>
  <div class="font-body-1 font-body-medium" data-testid="flight-summary-subtitle">
    {{ (bound$ | async).departure.dateTime | finDateFormat: 'FULL' }}
  </div>

  <div class="ms-xsmall-y flex flex-row flex--middle">
    <fin-endpoint-time [endpoint]="b.departure" />
    <div class="flex--nogrow font-body-1 ps-medium-x font-body-medium">
      <fcom-icon class="icon-medium" [name]="icon$ | async" />
    </div>
    <fin-endpoint-time [endpoint]="b.arrival" [reverse]="true" />
  </div>
  <div class="font-body-2 ms-xsmall-b ps-small-r font-body-small" *ngIf="false">
    <button class="view-detail-button nordic-blue-900-text text-icon-primary underline">
      {{ 'ticketSelection.viewTripItineraryDetails' | finLocalization }}
    </button>
  </div>
  <div class="summary-info ms-xsmall-b font-body-1 font-body-medium">
    <div class="label nordic-blue-900-text text-icon-primary">{{ 'bookingSummary.from.title' | finLocalization }}</div>
    <div class="location medium-type">{{ b.departure['cityName'] }} ({{ b.departure.locationCode }})</div>
  </div>
  <div class="summary-info ms-xsmall-b font-body-1 font-body-medium">
    <div class="label nordic-blue-900-text text-icon-primary">{{ 'bookingSummary.to.title' | finLocalization }}</div>
    <div class="location medium-type">{{ b.arrival['cityName'] }} ({{ b.arrival.locationCode }})</div>
  </div>
  <div class="summary-info ms-xsmall-b font-body-1 font-body-medium">
    <div class="label nordic-blue-900-text text-icon-primary">{{ 'flightDuration' | finLocalization }}</div>
    <div class="duration medium-type">
      {{ 'bookingSearch.duration' | finLocalization: (b?.duration | finTemporaryDurationPipe) }}
    </div>
  </div>
  <div class="summary-info ms-xsmall-b font-body-1 font-body-medium">
    <div class="label nordic-blue-900-text text-icon-primary">
      {{ 'bookingSummary.numberOfStops' | finLocalization }}
    </div>
    <div class="stops medium-type" *ngIf="$safeNavigationMigration(b?.stops) !== undefined" [ngSwitch]="b?.stops">
      <ng-container *ngSwitchCase="0">{{ 'bookingSummary.directFlight' | finLocalization }}</ng-container>
      <ng-container *ngSwitchCase="1">{{ 'stopOver' | finLocalization: [b?.stops] }}</ng-container>
      <ng-container *ngSwitchDefault>{{ 'stopOvers' | finLocalization: [b?.stops] }}</ng-container>
    </div>
  </div>
  <div class="summary-info ms-xsmall-b font-body-1 font-body-medium" *ngIf="b?.fareFamily?.name">
    <div class="label nordic-blue-900-text text-icon-primary">{{ 'bookingSummary.ticketType' | finLocalization }}</div>
    <div class="ticket-type medium-type">{{ b?.fareFamily?.name }}</div>
  </div>
  <div class="summary-info font-body-1 font-body-medium" *ngIf="flights$ | async as flights">
    <ng-container *ngIf="flights[0].bookingClass">
      <div class="ms-xsmall-b">
        <div class="label nordic-blue-900-text text-icon-primary">{{ 'travelClasses' | finLocalization }}</div>
        <div *ngFor="let flight of flights" class="medium-type" data-testid="booking-summary-flights">
          {{ flight.departure.locationCode }}—{{ flight.arrival.locationCode }}
          <ng-container *ngIf="flight.cabinClass">
            {{ 'travelClass.' + flight.cabinClass?.toLowerCase() | finLocalization }}
            {{ flight.bookingClass }}
          </ng-container>
          <ng-container *ngIf="!flight.cabinClass">
            {{ 'bookingSummary.noTravelClass' | finLocalization }}
          </ng-container>
        </div>
      </div>
    </ng-container>
    <div class="label nordic-blue-900-text text-icon-primary">{{ 'bookingSummary.operatedBy' | finLocalization }}</div>
    <div *ngFor="let flight of flights" class="medium-type">
      {{ flight.departure.locationCode }}—{{ flight.arrival.locationCode }} {{ flight.operatingAirline?.name }}
    </div>
  </div>
</div>
